import styled from 'styled-components'
import CardWraper from 'react-bootstrap/Card'
import { CardProps } from './typings'
import { colors } from '../../../const/theme'
import HighchartsReact from 'highcharts-react-official'

export const Card = styled(CardWraper)<CardProps>`
  width: 25%;
  height: 7rem;
  @media (max-width: 415px) {
    width: 100%;
  }
  align-items: center;
  padding: 12px;
  margin: 12px;
  background: ${({ color }) => color};
  color: ${colors.white};
`

export const CardBody = styled(CardWraper.Body)`
  text-align: center;
`

export const HighChartUI = styled(HighchartsReact)`
  width: 50%;
  .highcharts-root {
    width: 50%;
  }
  @media (max-width: 415px) {
    width: 100%;
    .highcharts-root {
      width: 100%;
    }
  }
`
